// extracted by mini-css-extract-plugin
export default {"container":"wiki_container__S1JGq","title":"wiki_title__TYdxD","description":"wiki_description__ep9gN","section":"wiki_section__0nwwK"};